import React, { useState } from "react";
import "../css/register.css";
import { addUser, validateUser } from "./apiService";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");
  const [errors, setErrors] = useState({});
  // const [user, setUser] = useState("[]");
  // const [users, setUsers] = useState("[]");
  const navigate = useNavigate();

  // useEffect(() => {
  //   getUser()
  //     .then((res) => {
  //       setUsers(res);
  //       console.log(res);
  //     })
  //     .catch((e) => console.log(e));
  // }, []);

  const handleRegisterSubmit = async () => {
    let errors = {};
    const re1 = new RegExp("^[6-9][0-9]{9}$");
    const re2 = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z.]+.[a-zA-Z]{2,}$");

    if (!username) errors.username = "User name is required";
    if (!re2.test(email)) errors.email = "Email is required";
    if (!re1.test(mobileno)) errors.mobileno = "Enter valid Mobile No";
    if (!password) errors.password = "Password is required";
    if (!cpassword) errors.cpassword = "Confirm password is required";
    if (password !== cpassword) errors.pmatch = "Passwords didn't match";

    let user = await validateUser(username, mobileno, email);
    console.log(user.user);

    // console.log(user.username);
    if (user.user === "Exist") {
      errors.username = "username already taken";
      // console.log(errors.username);
    }
    if (user.mobileNo === "Exist") {
      errors.mobileno = "Mobile no already Registerd";
      // console.log(errors.mobileno);
    }
    if (user.email === "Exist") {
      errors.email = "Email id already in use";
      // console.log(errors.mobileno);
    }

    setErrors(errors);
    // console.log(Object.keys(errors).length);

    if (Object.keys(errors).length === 0) {
      const user = {
        username: username,
        email: email,
        mobileno: mobileno,
        password: password,
      };
      // setUser(user1);

      addUser(user);

      setUsername("");
      setEmail("");
      setMobileno("");
      setPassword("");
      setCpassword("");
      navigate("/Login");
    }
  };

  return (
    <div className="container-box">
      <div className="container">
        <div className="header">Register Here...</div>
        <div className="label">
          UserName:
          <input
            type="text"
            className="inputbox"
            name="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          {errors.username ? (
            <div className="errortext">{errors.username}</div>
          ) : null}
        </div>

        <div className="label">
          E-mail:
          <input
            type="email"
            className="inputbox"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email ? (
            <div className="errortext">{errors.email}</div>
          ) : null}
        </div>

        <div className="label">
          Mobile No:
          <input
            type="text"
            className="inputbox"
            name="mobileno"
            value={mobileno}
            onChange={(e) => setMobileno(e.target.value)}
          />
          {errors.mobileno ? (
            <div className="errortext">{errors.mobileno}</div>
          ) : null}
        </div>

        <div className="label">
          Password:
          <input
            type="password"
            className="inputbox"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {errors.password ? (
            <div className="errortext">{errors.password}</div>
          ) : null}
        </div>

        <div className="label">
          Confirm Password:
          <input
            type="password"
            className="inputbox"
            name="cpassword"
            value={cpassword}
            onChange={(e) => setCpassword(e.target.value)}
          />
          {errors.cpassword ? (
            <div className="errortext">{errors.cpassword}</div>
          ) : null}
        </div>
        {errors.pmatch ? (
          <div className="errortext">{errors.pmatch}</div>
        ) : null}

        <input
          type="submit"
          className="btn-cls"
          value="Register"
          onClick={handleRegisterSubmit}
        />
        <div className="label1">
          Already Registered..? Please{" "}
          <span onClick={() => navigate("/Login")}>Sign In</span> here..
        </div>
      </div>
    </div>
  );
};

export default Register;
